import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const FacebookOAuthCallback = () => {
  const { t } = useTranslation("common");
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");

    if (code && window.opener) {
      // Send code to main window
      window.opener.postMessage(
        { source: "facebook-oauth", code },
        window.location.origin, // Or "*" if you need to support multiple origins
      );
      window.close();
    }
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>{t("oauth.processingCode")}</h1>
    </div>
  );
};
